import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import AddCustomFieldModal from './AddCustomFieldModal';

export const modalId = 'add-custom-field-modal';

const useAddCustomFieldModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openAddCustomFieldModal = () => {
    openModal({
      id: modalId,
      title: t('pageAutomations.customFields.addCustomField'),
      customContent: <AddCustomFieldModal modalId={modalId} />,
    });
  };

  return { openAddCustomFieldModal };
};

export default useAddCustomFieldModal;
